// extracted by mini-css-extract-plugin
module.exports = {"titreDeux":"onboarding_titreDeux__2AWAi","generalButton":"onboarding_generalButton__5It2F","lienSimple":"onboarding_lienSimple__pEkP3"};